import {
  getActionPlansByLast12MonthsApi,
  getHazardsByLast12MonthsApi,
  getInvestedPercentileByHazardApi,
  getMachinesCountAndInvestmentsByHazardApi,
  getRisksPercentageByHazardApi,
} from "@/api/admin/company-report";

export function fetchRisksPercentageByHazard({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return getRisksPercentageByHazardApi({
    unitId,
    businessType,
    sector,
    corporateGroupId,
    machineId,
  });
}

export function fetchMachinesCountAndInvestmentsByHazard({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return getMachinesCountAndInvestmentsByHazardApi({
    unitId,
    businessType,
    sector,
    corporateGroupId,
    machineId,
  });
}

export function fetchInvestedPercentileByHazard({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return getInvestedPercentileByHazardApi({
    unitId,
    businessType,
    sector,
    corporateGroupId,
    machineId,
  });
}

export function fetchActionPlansByLast12Months({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return getActionPlansByLast12MonthsApi({
    unitId,
    businessType,
    sector,
    corporateGroupId,
    machineId,
  });
}

export function fetchHazardsByLast12Months({
  unitId,
  corporateGroupId,
  sector,
  businessType,
  machineId,
}) {
  return getHazardsByLast12MonthsApi({
    unitId,
    businessType,
    sector,
    corporateGroupId,
    machineId,
  });
}